import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 1
const slug = 'bulk-detailed-excavation-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: `Bulk & Detailed Excavation Sydney | ${BUSINESS_NAME}`,
        description: "Site preparation and excavation for small to large-scale projects.",
        keywords: "bulk excavation Sydney, detailed excavation Sydney, site preparation, land clearing, trenching services, residential excavation, commercial excavation, industrial excavation, earthmoving services, Sydney construction services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Bulk & Detailed Excavation',
    description: 'Site preparation and excavation for small to large-scale projects.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
